module.exports = __webpack_public_path__ + "static/media/note1.7507e4b2.svg";